import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Gikam from 'gikam';
export var TransferUtils = /*#__PURE__*/function () {
  function TransferUtils() {
    _classCallCheck(this, TransferUtils);
  }

  _createClass(TransferUtils, null, [{
    key: "init",
    value: function init(options, transfer) {
      var h = this.$createElement;
      var renderTo = transfer.options.renderTo;
      new Vue({
        el: Gikam.createDom('div', renderTo),
        components: {
          Transfer: function Transfer() {
            return import('./transfer.vue');
          }
        },
        render: function render() {
          var h = arguments[0];
          return h("Transfer", {
            "attrs": {
              "options": options
            }
          });
        }
      });
    }
  }]);

  return TransferUtils;
}();